/**
 * Section-break ornament — a thin ink hairline broken by a row of evenly
 * spaced palette dots. Reads like an Aesop-style "monogrammed" break;
 * the palette rotation quietly reintroduces the brand colors without
 * committing to any single one.
 *
 * Props:
 *   variant: "a" (tight & petite) | "b" (airy & confident). Default "a".
 *   className: pass-through wrapper class.
 */

const PALETTE = [
  { key: "tangerine", cls: "bg-tangerine" },
  { key: "cobalt",    cls: "bg-cobalt"    },
  { key: "grass",     cls: "bg-grass"     },
  { key: "blossom",   cls: "bg-blossom"   },
  { key: "yellow",    cls: "bg-yellow"    },
];

const VARIANTS = {
  a: { dot: "h-2 w-5",   gap: "gap-3" }, // 8×20 ovals, 12px gap (compact)
  b: { dot: "h-3 w-8",   gap: "gap-5" }, // 12×32 ovals, 20px gap (default)
};

export const DoodleDivider = ({ className = "", variant = "b" }) => {
  const v = VARIANTS[variant] || VARIANTS.a;
  return (
    <div
      aria-hidden="true"
      data-testid="doodle-divider"
      data-variant={variant}
      className={`mx-auto flex w-full max-w-7xl items-center gap-6 px-6 py-10 lg:px-8 lg:py-14 ${className}`}
    >
      <span className="h-px flex-1 bg-ink/15" />
      <div className={`flex items-center ${v.gap}`}>
        {PALETTE.map((c) => (
          <span
            key={c.key}
            data-testid={`doodle-divider-dot-${c.key}`}
            className={`${v.dot} rounded-full ${c.cls}`}
          />
        ))}
      </div>
      <span className="h-px flex-1 bg-ink/15" />
    </div>
  );
};
